/* eslint-disable import/no-duplicates */
import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const scrollToAnchor = (locationHash) => {
  const hashParts = locationHash.split('#');
  if (hashParts.length >= 2) {
    const hash = hashParts.slice(-1)[0];
    const ele = document.querySelector(`#${hash}`);
    // eslint-disable-next-line no-unused-expressions
    if (ele) {
      return ele.scrollIntoView();
    }
  }

  // 默认情况下滚动到页面顶部
  return window.scrollTo(0, 0);
};

export function useHashScroll() {
  const history = useHistory();
  // 如果没有切页面，只是hash变化，页面不会重新渲染
  useEffect(() => {
    scrollToAnchor(history.location.hash);
  }, [history.location.hash]);

  // 如果切了页面，需要等待元素渲染结束，图片加载完成
  useEffect(() => {
    setTimeout(() => {
      scrollToAnchor(history.location.hash);
    }, 100);
  }, [history]);
}

interface IProps {
  voice: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  toggleVoice: any;
}

export const VoiceContext = React.createContext<Partial<IProps>>({
  voice: true,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  toggleVoice: () => {}
});
